import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Transfer } from "../../interfaces/HairTransfer";
import { HairStyle, HairType } from "../../interfaces/hairType";
import { fetchGetCategoryV5 } from "../../services/category";

interface HairState {
  categorySelected?: HairType | undefined;
  isStyleLoading: boolean;
  selectedHairStyles?: HairStyle[];
  selectedTransfer?: Transfer;
  categoryIsPending: boolean;
}

export const styleSlice = createSlice({
  name: "style",
  initialState: {
    categories: undefined,
    categorySelected: undefined,
    categoryIsPending: true,
    genomeIds: "",
    selectedHairStyles: undefined,
    selectedTransfer: undefined,
    isStyleLoading: false,
    isError: false,
  },
  reducers: {
    setCategoryIsPending: (state, action) => {
      state.categoryIsPending = action.payload;
    },
    resetError: (state) => {
      state.isError = false;
    },
    setIsStyleLoading: (state, action) => {
      state.isStyleLoading = action.payload;
      // state.selectedTransfer = undefined;
    },
    setCategoryStyle: (
      state: HairState,
      action: PayloadAction<HairStyle[]>
    ) => {
      state.categorySelected
        ? (state.categorySelected.hairStyles = action.payload)
        : state.categorySelected;
      state.isStyleLoading = false;
    },
    setCategorySelected: (state, action) => {
      state.categorySelected = action.payload;
      state.isStyleLoading = false;
    },
    setGenomeIds: (state, action) => {
      state.genomeIds = action.payload;
      state.isStyleLoading = false;
    },
    setSelectedHairStyles: (state, action) => {
      state.selectedHairStyles = action.payload;
      state.isStyleLoading = false;
    },
    setSelectedTransfer: (state, action) => {
      state.selectedTransfer = action.payload;
      state.isStyleLoading = false;
    },
  },
  extraReducers(builder) {
    builder.addCase(fetchGetCategoryV5.fulfilled, (state, action) => {
      state.categories = action.payload?.data;
      state.isStyleLoading = false;
    });
  },
});

export const {
  setCategorySelected,
  setGenomeIds,
  setSelectedHairStyles,
  setSelectedTransfer,
  setIsStyleLoading,
  setCategoryStyle,
  setCategoryIsPending,
  resetError,
} = styleSlice.actions;

export default styleSlice.reducer;
